import React from 'react';
import { Input } from 'antd';
import { Field } from '@src/components/Common/Form';
import RateLimitFields from '@src/components/LLMModels/LLMForms/RateLimitFields';

/** What every provider that speaks the chat-completions API needs. */
const ChatCompletionModelForm = () => (
    <>
        {/* a key and a URL are long values — they get half the row each */}
        <Field
            name={['extra_data', 'api_key']}
            label="API key"
            span={6}
            rules={[{ required: true, message: 'Enter the API key' }]}
        >
            <Input.Password className="nf-mono" placeholder="Enter API key" visibilityToggle={false} autoComplete="off" />
        </Field>

        <Field
            name={['extra_data', 'base_url']}
            label="Base URL"
            span={6}
            rules={[{ type: 'url', message: 'Enter a full URL, including https://' }]}
        >
            <Input className="nf-mono" placeholder="https://api.example.com/v1" inputMode="url" />
        </Field>

        <RateLimitFields />
    </>
);

export default ChatCompletionModelForm;
